import React from 'react';
import { string, func, arrayOf } from 'prop-types';
import classNames from 'classnames';
import css from './CurrencySelector.module.css';

const DEFAULT_CURRENCIES = ['EUR', 'USD', 'GBP', 'CHF', 'SEK', 'NOK', 'DKK', 'PLN', 'CZK'];

/**
 * CurrencySelector — dropdown to select preferred display currency.
 *
 * Usage (in Topbar or user preferences):
 *   const { currency, setCurrency } = useCurrency();
 *   <CurrencySelector value={currency} onChange={setCurrency} />
 */
const CurrencySelector = ({ value, onChange, currencies, className }) => {
  const available = currencies || DEFAULT_CURRENCIES;

  return (
    <select
      value={value}
      onChange={e => onChange(e.target.value)}
      className={classNames(css.select, className)}
      aria-label="Select currency"
    >
      {available.map(code => (
        <option key={code} value={code}>{code}</option>
      ))}
    </select>
  );
};

CurrencySelector.defaultProps = { currencies: null, className: null };
CurrencySelector.propTypes = { value: string.isRequired, onChange: func.isRequired, currencies: arrayOf(string), className: string };

export default CurrencySelector;
